
import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { Grommet } from 'grommet';

import AutorPage from './components/AutorPage';
import HomePage from './components/HomePage';
import MapPage from './containers/MapPage';
import MarkdownPage from './components/MarkdownPage';
import OdrudaDetailPage from './containers/OdrudaDetailPage';
import OdrudaSsrPage from './containers/OdrudaSsrPage';
import OdrudaListPage from './containers/OdrudaListPage';
import TratDetailPage from './containers/TratDetailPage';
import TratListPage from './containers/TratListPage';

import { MARKDOWN_PAGES } from './MarkdownPages';
import PageTracking from './PageTracking';

const theme = {
    global: {
        font: {
            family: 'Roboto',
            size: '14px',
            height: '20px'
        }
    },
    // ToDo:
    paragraph: {
        xlarge: {
            maxWidth: "900px"
        },
        medium: {
            maxWidth: "900px"
        },
        small: {
            maxWidth: "900px"
        }
    }
};

const getRoutes = () => {
    let routes = [
        <Route key="1" path="/" exact component={HomePage} />,
        <Route key="2" path="/autor/" component={AutorPage} />,
        <Route key="3" path="/map/" component={MapPage} />,
        <Route key="4" path="/odrudy/" component={OdrudaListPage} />,
        <Route key="5" path="/odruda/:id" component={OdrudaDetailPage} />,
        <Route key="6" path="/odrudassr/:id" component={OdrudaSsrPage} />,
        <Route key="7" path="/trate/" component={TratListPage} />,
        <Route key="8" path="/trat/:id" component={TratDetailPage} />
    ];

    MARKDOWN_PAGES.forEach((item, index) => {
        let fileName = require(`./components/md/${item}.md`);
        let component = () => {
            return (
                <MarkdownPage
                    fileName={fileName}
                />
            );
        };
        routes.push(
            <Route key={index + 100} path={`/link_${item}`} component={component} />
        );
    });
    return routes;
}

const App = (props) => {
    return (
        <>
            <PageTracking />
            <Router>
                <Grommet full theme={theme}>
                    {getRoutes()}
                </Grommet>
            </Router>
        </>
    );
}

export default App;
